<template>
<div class="detail-wrap" >
    <div class="mg-l-10">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick" >
            <el-tab-pane label="已发布赛事" name="a">
                <PublishTab ref="pubTab"></PublishTab>
            </el-tab-pane>
            <el-tab-pane label="待发布赛事" name="b">
                <PreviewTab ref="preTab"></PreviewTab>
            </el-tab-pane>
        </el-tabs>
    </div>
    </div>  
</template>
<script>

import PublishTab from './components/publishTab.vue'
import PreviewTab from './components/previewTab.vue'
import PageBack from '@/components/PageHeader'
export default {
    components:{
        PublishTab,
        PreviewTab,
        PageBack
    },
    data(){
        return{
            activeName: 'a', 
        }
    },
    computed:{
        title(){
            return this.$route.meta.title
        },
        userId(){
            return localStorage.getItem('playerNo')
        },
        roles(){
            return localStorage.getItem('roles')
        }    
    },
    created(){

    },
    mounted(){

    },
    methods:{
        handleClick(){
            if(this.activeName === 'a'){
                this.$refs.pubTab.initData()
            }else if(this.activeName === 'b'){
                this.$refs.preTab.initData()
            }
        }
    }
}
</script>

<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.mg-l-10{
    margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/publish/newPublish.vue